import React, { useState } from 'react';
    import Header from '../components/Header';
    import Footer from '../components/Footer';
    import Button from '../components/Button';
    import TidyCalModal from '../components/TidyCalModal';
    import { motion } from 'framer-motion';
    import * as FiIcons from 'react-icons/fi';
    import SafeIcon from '../common/SafeIcon';

    const { FiMail, FiMapPin, FiClock } = FiIcons;

    const ContactPage = () => {
      const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
        company_name: ''
      });
      const [isModalOpen, setIsModalOpen] = useState(false);
      const [isSubmitted, setIsSubmitted] = useState(false);
      const [isSubmitting, setIsSubmitting] = useState(false);

      const emailImage = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyODAiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyODAgMjQiIGZpbGw9Im5vbmUiPjx0ZXh0IHg9IjAiIHk9IjE4IiBmaWxsPSIjNEI1NTYzIiBmb250LWZhbWlseT0iSW50ZXIsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMTZweCI+ZGl2b3JjZXdpdGhkaXJlY3Rpb25AZ21haWwuY29tPC90ZXh0Pjwvc3ZnPg==";

      const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.company_name) {
          setIsSubmitted(true);
          return;
        }
        setIsSubmitting(true);
        // Form submission logic...
        setTimeout(() => {
          setIsSubmitted(true);
          setIsSubmitting(false);
        }, 1000);
      };

      const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      };

      return (
        <div className="min-h-screen">
          <Header />
          <main className="pt-12">
            <section className="py-20 bg-sage-50">
              <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.h1 initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="text-4xl md:text-5xl font-canela font-light text-gray-900 mb-6"> Get in Touch </motion.h1>
                <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="text-xl text-gray-700 font-inter leading-relaxed"> Ready to take the next step? I'm here to support you through your journey. </motion.p>
              </div>
            </section>
            <section className="py-20 bg-white">
              <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                  <motion.div initial={{ opacity: 0, x: -30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8 }}>
                    <h2 className="text-3xl font-canela font-light text-gray-900 mb-6">Send a Message</h2>
                    {isSubmitted ? (
                      <div className="bg-sage-50 p-8 rounded-2xl text-center">
                        <h3 className="text-xl font-canela font-medium text-gray-900 mb-2">Message Sent</h3>
                        <p className="text-gray-600">Thanks — your message has been sent.</p>
                      </div>
                    ) : (
                      <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="hidden"><input type="text" name="company_name" value={formData.company_name} onChange={handleChange} /></div>
                        <div>
                          <label className="block text-sm font-inter font-medium text-gray-700 mb-2">Name *</label>
                          <input type="text" name="name" required className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
                        </div>
                        <div>
                          <label className="block text-sm font-inter font-medium text-gray-700 mb-2">Email *</label>
                          <input type="email" name="email" required className="w-full px-4 py-3 border border-gray-300 rounded-lg" />
                        </div>
                        <div>
                          <label className="block text-sm font-inter font-medium text-gray-700 mb-2">Message *</label>
                          <textarea name="message" required rows={6} className="w-full px-4 py-3 border border-gray-300 rounded-lg resize-none" />
                        </div>
                        <Button type="submit" size="lg" className="w-full" disabled={isSubmitting}> {isSubmitting ? 'Sending...' : 'Send Message'} </Button>
                      </form>
                    )}
                  </motion.div>
                  <motion.div initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.8, delay: 0.2 }} className="space-y-8">
                    <h2 className="text-3xl font-canela font-light text-gray-900 mb-6">Contact Information</h2>
                    <div className="space-y-6">
                      <div className="flex items-start space-x-4">
                        <div className="w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center flex-shrink-0"> <SafeIcon icon={FiMail} className="h-5 w-5 text-sage-400" /> </div>
                        <div>
                          <h3 className="text-lg font-inter font-medium text-gray-900 mb-1">Email</h3>
                          <img src={emailImage} alt="Contact Email" className="h-6 object-contain" />
                        </div>
                      </div>
                      <div className="flex items-start space-x-4">
                        <div className="w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center flex-shrink-0"> <SafeIcon icon={FiClock} className="h-5 w-5 text-sage-400" /> </div>
                        <div>
                          <h3 className="text-lg font-inter font-medium text-gray-900 mb-1">Hours</h3>
                          <p className="text-gray-600">Monday - Friday: 9:00 AM - 6:00 PM</p>
                        </div>
                      </div>
                      <div className="flex items-start space-x-4">
                        <div className="w-12 h-12 bg-sage-100 rounded-full flex items-center justify-center flex-shrink-0"> <SafeIcon icon={FiMapPin} className="h-5 w-5 text-sage-400" /> </div>
                        <div>
                          <h3 className="text-lg font-inter font-medium text-gray-900 mb-1">Sessions</h3>
                          <p className="text-gray-600">Virtual sessions via secure video platform</p>
                        </div>
                      </div>
                    </div>
                    <div className="bg-sage-50 p-6 rounded-lg">
                      <h3 className="text-lg font-inter font-medium text-gray-900 mb-3">Ready to Schedule?</h3>
                      <p className="text-gray-600 text-sm mb-4">I offer a complimentary 15-minute consultation to discuss your needs.</p>
                      <Button variant="secondary" onClick={() => setIsModalOpen(true)}>Schedule Consultation</Button>
                    </div>
                  </motion.div>
                </div>
              </div>
            </section>
          </main>
          <Footer />
          <TidyCalModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </div>
      );
    };

    export default ContactPage;